import { Paper, Grid, Typography } from "@mui/material"

type Item = {
    label: string
    value: string | number | React.ReactNode
}

type Props = {
    title?: string
    items: Item[]
}

const BasicInfoSection = ({
    title,
    items
}: Props) => {
    return (
        <Paper sx={{ p: 2, borderRadius: 2, mb: 2 }}>
            {/* {title && (
                <Typography variant="h5" mb={2}>
                    {title}
                </Typography>
            )} */}

            <Grid container spacing={2}>
                {items.map((item, index) => (
                    <Grid item xs={12} md={6} key={index}>
                        <Typography variant="caption" mb={0.5}>
                            {item.label}
                        </Typography>

                        <Typography variant="h6">
                            {item.value || "-"}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    )
}

export default BasicInfoSection